import styled from 'styled-components';

export const Container = styled.div`
  width: 95%;
  margin:0 auto;
  background: #FFFFFF;

  @media (min-width: 1600px ){
    max-width: 1520px;
  }

  @media (min-width: 1360px ) and (max-width: 1600px ){
    max-width: 1320px;
  }

  @media (max-width: 1360px ){
    max-width: 1100px;
  }
`;

export const SearchBarBox = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
  justify-content: center;
`;

export const SearchInput = styled.input`
  width: 85%;
  padding: 8px;
  font-size: 14px;
`

export const SearchButton = styled.button`
  width: 12.5%;
  padding: 8px 6px;
  margin: 0 4px;
  font-size: 16px;
`

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-evenly;
  border: solid 1px #555;
  padding: 16px 8px;
  margin-bottom: 6px;
  width: 100%;
`;

export const DataBox = styled.div`
  display: flex;
  border: solid 1px #444;
  flex-direction: row;
  overflow: auto;
  padding: 6px 18px 0;
  max-height: 500px;
  width: 100%;
  flex-wrap: nowrap;
  align-items: center;

  @media (min-width: 1600px ){
    max-height: 600px;
  } 

  h2 {
    text-align: center;
    padding: 12px;
  }
`;

export const Modulo = styled.div`
  display: flex;
  flex-direction: column;
  border: solid 1px #333;
  margin: 8px 12px auto 12px;
  padding: 2px;
  min-width: 200px;
  max-width: 200px;
`;

export const NameModulo = styled.p`
  font-size: 14px;
  padding: 4px 2px;
  text-align: center;
`;

export const Licao = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: solid 1px #222;
  padding: 4px;
  margin: 2px;
`;

export const NameLicao = styled.p`
  font-size: 12px;
  text-align: center;
`;